import Committee from "../components/Committee/Committee";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";
import Organising from "../components/Organising/Organising";
import avatar from "../components/assets/avatar.png"
import o1 from "../components/assets/o1.png";
import o2 from "../components/assets/o2.png";
import o3 from "../components/assets/o3.png";
import o4 from "../components/assets/o4.png";
import o5 from "../components/assets/o5.png";
import o6 from "../components/assets/o6.png";
import o7 from "../components/assets/o7.png";
import o8 from "../components/assets/o8.png";
import o9 from "../components/assets/o9.png";
// import o10 from "../components/assets/o10.png";
const OrganizingCommittee = () => {
    const OrganisingMembers = [
        {
            name: "Prof. R. S. Verma",
            designation: "Director, MNNIT Allahabad",
            role: "Patron",
            imageUrl:
                o1,
          },
          
          {
            name: "Prof. Shivesh Sharma",
            designation: "MNNIT Allahabad",
            role: "Chairperson",
            imageUrl:
                o2,
          },
          {
            name: "Head [Ex-Offcio]",
            designation: "Department of Biotechnology, MNNIT Allahabad",
            role: "Vice-Chairperson",
            imageUrl:
                o3,
          },
          
          {
            name: "Dr. Ambak Kumar Rai",
            designation: "MNNIT Allahabad   ",
            role: "Convener/ Organizing Secretary ",
            imageUrl:
                o4,
          },
          {
            name: "Dr. Sameer Srivastava",
            designation: "MNNIT Allahabad",
            role: "Co-convener/ Co-Organizing Secretary",
            imageUrl:
                o5,
          },
          {
            name: "Dr. Manisha Sachan",
            designation: "MNNIT Allahabad",
            role: "Joint Organizing Secretary",
            imageUrl:
                o6,
          },
          {
            name: "Dr. Seema Nara",
            designation: "MNNIT Allahabad",
            role: "Joint Organizing Secretary",
            imageUrl:
                o7,
          },
          {
            name: "Dr. Vishnu Agarwal",
            designation: "MNNIT Allahabad",
            role: "Joint Organizing Secretary",
            imageUrl:
                o8,
          },
          {
            name: "Dr. Abhishek Kumar Tiwari",
            designation: "MNNIT Allahabad",
            role: "Joint Organizing Secretary, Treasurer",
            imageUrl:
                o9,
          },
      ];
    return (
        <>
        <Header/>
        <Navbar />
        <Organising  heading="Organizing Committee"  people={OrganisingMembers}/>
        
      </>
    );
  };
  
  export default OrganizingCommittee;
  